import getTBWStore from "../../../stores/developer-store/tbw-store";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import AuditProofPopUp from "./audit-proof-pop-up";
import AuditReasonsPopUp from "./audit-reason-pop-up";
import SuperviseProofPopUp from "./supervise-proof-pop-up";
import SuperviseReasonsPopUp from "./supervise-reason-pop-up";
import TBWPopUp from "./tbw-pop-up";

const CustomAlert = withLiteObserverAndTheme(() => {
  const type = getTBWStore().TBWPopUpType.get();

  switch (type) {
    case "ACTION_TBW":
      return <TBWPopUp />;
    case "AUDIT_REASON":
      return <AuditReasonsPopUp />;
    case "AUDIT_PROOF":
      return <AuditProofPopUp />;
    case "SUPERVISE_REASON":
      return <SuperviseReasonsPopUp />;
    case "SUPERVISE_PROOF":
      return <SuperviseProofPopUp />;
    default:
      return null;
  }
});

export default CustomAlert;
